module.exports = __webpack_public_path__ + "img/uchwyt-na-narty--snowboard.d1ae5b8a.jpg";